var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnterFullscreen = function SvgEnterFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1.5A1.5 1.5 0 0 0 1.5 3v5.25a.75.75 0 0 0 1.5 0V3h5.25a.75.75 0 0 0 0-1.5zM21 22.5a1.5 1.5 0 0 0 1.5-1.5v-5.25a.75.75 0 0 0-1.5 0V21h-5.25a.75.75 0 0 0 0 1.5zM3 22.5A1.5 1.5 0 0 1 1.5 21v-5.25a.75.75 0 0 1 1.5 0V21h5.25a.75.75 0 0 1 0 1.5zM22.5 3A1.5 1.5 0 0 0 21 1.5h-5.25a.75.75 0 0 0 0 1.5H21v5.25a.75.75 0 0 0 1.5 0z"
  })));
};
export default SvgEnterFullscreen;